const initialState = {
  vehicles: [],
};

export const vehicleReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_VEHICLES":
      return {
        ...state,
        vehicles: [action.payload],
      };

    case "UPDATE_VEHICLE":
      let newList = [];
      for (let i = 0; i < Array.from(state.vehicles[0]).length; i++) {
        const vehicle = Array.from(state.vehicles[0])[i];
        if (i === action.payload[1]) {
          newList.push(action.payload[0]);
        } else {
          newList.push(vehicle);
        }
      }

      return {
        ...state,
        vehicles: [newList],
      };

    case "REMOVE_VEHICLE":
      return {
        ...state,
        vehicles: [
          state.vehicles[0].filter(
            (vehicle) => vehicle.matricula !== action.payload
          ),
        ],
      };

    default:
      return state;
  }
};
